/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Delete_DescriptionInputs */

const en_admin_invite_codes_delete_description = /** @type {(inputs: Admin_Invite_Codes_Delete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone.`)
};

const zh_admin_invite_codes_delete_description = /** @type {(inputs: Admin_Invite_Codes_Delete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此操作不可撤销。`)
};

/**
* | output |
* | --- |
* | "This action cannot be undone." |
*
* @param {Admin_Invite_Codes_Delete_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_delete_description = /** @type {((inputs?: Admin_Invite_Codes_Delete_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Delete_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_delete_description(inputs)
	return zh_admin_invite_codes_delete_description(inputs)
});
export { admin_invite_codes_delete_description as "admin.invite_codes.delete_description" }